import { useTranslation } from 'next-i18next';
import styles from '@features/footer/Footer.styles';
const SimpleFooter = () => {
  const {
    t
  } = useTranslation('layouts');
  const actualYear = new Date().getFullYear();
  return <footer sx={styles.footerContainer}>
      <div sx={styles.footerContainerInner}>
        <div sx={styles.footerBottom(true)}>
          <div sx={styles.simpleFooterCopyRights}>{t('footer.rights', {
            actualYear
          })}</div>
        </div>
      </div>
    </footer>;
};
export default SimpleFooter;